import {instanceAxios} from "@/axios/axios";

export default function postFaqForm(data) {
    return new Promise((resolve, reject) => {
        instanceAxios.post('FAQappeal', data)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}